import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { LoginComponent } from './components/auth/login/login.component';
import { DataTableComponent } from './components/tables/data-table/data-table.component';
import { MyAssignmentComponent } from './components/my-assignment/my-assignment.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { ModalHeaderComponent } from './components/layouts/modal-header/modal-header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PageTitleComponent } from './components/layouts/page-title/page-title.component';
import { NgxPermissionsAllowStubModule, NgxPermissionsModule, NgxPermissionsRestrictStubModule } from 'ngx-permissions';
import { StrLimitPipe } from './pipes/str-limit.pipe';
import { QuillModule } from 'ngx-quill';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { AuthLayoutComponent } from './components/auth/auth-layout/auth-layout.component';
import { TranslateModule } from '@ngx-translate/core';
import { SafeResourcePipe } from './pipes/safe-resource.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SearchPipe } from './pipes/search.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { ShortNumberPipe } from './pipes/short-number.pipe';
import { MatSelectSearchComponent } from './components/custom-form-fields/mat-select-search/mat-select-search.component';
import { AppMainToolbarComponent } from './components/layouts/app-main-toolbar/app-main-toolbar.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';

import { SecondsToMinutesPipe } from './pipes/seconds-to-minutes';
import { StaffSidebarComponent } from './components/layouts/staff/staff-sidebar/staff-sidebar.component';
import { ModalFixedHeaderComponent } from './components/layouts/modal-fixed-header/modal-fixed-header.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { StaffLayoutComponent } from './components/layouts/staff/staff-layout/staff-layout.component';
import { CountPipe } from './pipes/count.pipe';
import { StrSpacePipe } from './pipes/str-space.pipe';

import { TextareaComponent } from './components/dynamic-forms-components/textarea/textarea.component';
import { SelectComponent } from './components/dynamic-forms-components/select/select.component';
import { RadiobuttonComponent } from './components/dynamic-forms-components/radiobutton/radiobutton.component';
import {
  MainDynamicFormComponent
} from './components/dynamic-forms-components/main-dynamic-form/main-dynamic-form.component';
import { InputComponent } from './components/dynamic-forms-components/input/input.component';
import { DynamicFieldDirective } from './components/dynamic-forms-components/dynamic-field/dynamic-field.directive';
import { DateRangeComponent } from './components/dynamic-forms-components/date-range/dateRange.component';
import { DateComponent } from './components/dynamic-forms-components/date/date.component';
import { CheckboxComponent } from './components/dynamic-forms-components/checkbox/checkbox.component';
import { ButtonComponent } from './components/dynamic-forms-components/button/button.component';
import { AttachmentComponent } from './components/dynamic-forms-components/attachment/attachment.component';
import { PortalLandingPageComponent } from './components/layouts/portal/portal-landing-page/portal-landing-page.component';
import { PortalLayoutComponent } from './components/layouts/portal/portal-layout/portal-layout.component';

import { FormatNumberPipe } from './pipes/format-number.pipe';
import { ReplacePipe } from './pipes/replace.pipe';
import { SplitCamelCasePipe } from './pipes/split-camel-case.pipe';
import { IsDateValidPipe } from './pipes/is-date-valid.pipe';
import { NgxPrintModule } from 'ngx-print';



import { PaginationButtonsComponent } from './components/tables/pagination-buttons/pagination-buttons.component';
import { TablePageableComponent } from './components/tables/table-pageable/table-pageable.component';
import { QRCodeModule } from 'angularx-qrcode';
import { NormalSignUpComponent } from './components/auth/normal-sign-up/normal-sign-up.component';
import { AgeLimitPipe } from './pipes/ageLimit.pipe';
import { AgePipe } from './pipes/age.pipe';
import { ObservablePipe } from './pipes/observable.pipe';
import { LengthPipe } from './pipes/length.pipe';
import { NgPipesModule } from 'ngx-pipes';

import {
  DateRangeFormFieldComponent
} from './components/custom-form-fields/date-range-form-field/date-range-form-field.component';
import { TableDownloadComponent } from './components/tables/table-download/table-download.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ReportLayoutComponent } from './components/layouts/report-layout/report-layout.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { PortalSidebarComponent } from './components/layouts/portal/portal-sidebar/portal-sidebar.component';
import { CdkCell, CdkHeaderCell, CdkHeaderRow, CdkRow, CdkTable } from '@angular/cdk/table';
import { LandingPageComponent } from './components/auth/landing-page/landing-page.component';
import { ConcatPipe } from './pipes/concat.pipe';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import {
  PortalInstitutionCardComponent
} from './components/layouts/portal/portal-institution-card/portal-institution-card.component';
import { AppMainHeaderComponent } from './components/layouts/app-main-header/app-main-header.component';
import { AppMainFooterComponent } from './components/layouts/app-main-footer/app-main-footer.component';
import { HomeLayoutComponent } from './components/layouts/home-layout/home-layout.component';
import { HomeSidebarComponent } from './components/layouts/home-layout/home-sidebar/home-sidebar.component';
import { MatCardModule } from '@angular/material/card';
import { NumberFormatDirective } from './directive/directive';
import { ApprovalWorkflowFormComponent } from './components/approval-workflow-form/approval-workflow-form.component';
import { FirmRegisteredComponent } from './components/auth/firm-registered/firm-registered.component';
import { ExternalUserLayoutComponent } from './components/layouts/external-user-layout/external-user-layout.component';
import { ExternalUserSideBarComponent } from './components/layouts/external-user-layout/external-user-side-bar/external-user-side-bar.component';
import { ChatWidgetComponent } from './components/layouts/staff/chat/chat.component';
import { HttpClientModule } from '@angular/common/http';

@NgModule({
  declarations: [
    LoginComponent, PageTitleComponent, DataTableComponent, MyAssignmentComponent, ModalHeaderComponent,
    StrLimitPipe, CountPipe, StrSpacePipe, AuthLayoutComponent, NormalSignUpComponent, SafeResourcePipe, StaffSidebarComponent, AppMainHeaderComponent,
    SearchPipe, MatSelectSearchComponent, AppMainToolbarComponent, LandingPageComponent,
    FilterPipe, SafeHtmlPipe, ShortNumberPipe, AppMainFooterComponent, SecondsToMinutesPipe, PortalLandingPageComponent,
    ModalFixedHeaderComponent, StaffLayoutComponent, PortalSidebarComponent,
    ReportLayoutComponent, PortalLayoutComponent, FormatNumberPipe, DateRangeFormFieldComponent,
    ConcatPipe, TableDownloadComponent,
    PaginationButtonsComponent, TablePageableComponent
    , HomeLayoutComponent, HomeSidebarComponent,
    NumberFormatDirective, ApprovalWorkflowFormComponent,
    FirmRegisteredComponent,

    /* Dynamic form components*/
    TextareaComponent,
    SelectComponent,
    RadiobuttonComponent,
    MainDynamicFormComponent,
    InputComponent,
    DynamicFieldDirective,
    DateRangeComponent,
    DateComponent,
    CheckboxComponent,
    ButtonComponent,
    AttachmentComponent,
    ReplacePipe,
    AgeLimitPipe,
    AgePipe,
    ObservablePipe,
    LengthPipe,
    SplitCamelCasePipe,
    IsDateValidPipe,
    ExternalUserLayoutComponent,
    ExternalUserSideBarComponent,
    ChatWidgetComponent
  ],
  imports: [
    MatMenuModule,
    CommonModule,
    MaterialModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    RouterModule,
    ReactiveFormsModule,
    QuillModule,
    QuillModule.forRoot(),
    NgxExtendedPdfViewerModule,
    TranslateModule,
    FormsModule,
    DragDropModule,
    NgxPermissionsModule.forChild(),
    NgxPermissionsRestrictStubModule,
    ImageCropperModule,
    NgxPrintModule,
    QRCodeModule,
    NgPipesModule,
    ScrollingModule,
    NgxDropzoneModule,
    CdkHeaderRow,
    CdkRow,
    CdkTable,
    CdkHeaderCell,
    CdkCell,
    NgxMaskDirective,
    NgxMaskPipe,
    MatCardModule,
    HttpClientModule,
    FormsModule,
    MatButtonModule,
    MatIconModule
    // HomeModule,
  ],
  exports: [
    NumberFormatDirective,
    NgxPermissionsModule,
    NgxPermissionsAllowStubModule,
    MaterialModule,
    DataTableComponent,
    MyAssignmentComponent,
    ModalHeaderComponent,
    PageTitleComponent,
    StrLimitPipe,
    QuillModule,
    NgxPrintModule,
    SearchPipe,
    FilterPipe,
    ShortNumberPipe,
    MatSelectSearchComponent,
    SafeHtmlPipe,
    ReactiveFormsModule,
    TranslateModule,
    ModalFixedHeaderComponent,
    StaffLayoutComponent,
    HomeLayoutComponent,
    ExternalUserLayoutComponent,
    CountPipe,
    StrSpacePipe,
    MainDynamicFormComponent,
    PortalLayoutComponent,
    AppMainToolbarComponent,
    FormatNumberPipe,
    ReplacePipe,
    SafeResourcePipe,
    TablePageableComponent,
    SplitCamelCasePipe,
    DateRangeFormFieldComponent,
    TableDownloadComponent,
    ReportLayoutComponent,
    ConcatPipe,
    ApprovalWorkflowFormComponent,
    ChatWidgetComponent
  ],
  providers: [provideNgxMask()]
})
export class SharedModule { }
